import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { LocationPageHero } from '../../components/locations/LocationPageHero';
import { LocationHighlights } from '../../components/locations/LocationHighlights';
import { LocationGallery } from '../../components/locations/LocationGallery';
import { BridgeportProgramsPricing } from '../../components/locations/BridgeportProgramsPricing';
import { LocationSchedule } from '../../components/locations/LocationSchedule';
import { LocationContactForm } from '../../components/locations/LocationContactForm';
import { getLocationById } from '../../data/locations';
export function BridgeportPage() {
  const location = getLocationById('bridgeport');
  if (!location) {
    return <div data-id="element-929">Location not found</div>;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-930">
      <Header data-id="element-931" />

      <main data-id="element-932">
        <LocationPageHero location={location} data-id="element-933" />
        <LocationHighlights highlights={location.highlights} locationName={location.name} data-id="element-934" />
        {location.galleryImages && location.galleryImages.length > 0 && <LocationGallery images={location.galleryImages} locationName={location.name} data-id="element-935" />}
        <BridgeportProgramsPricing data-id="element-936" />
        <LocationSchedule schedule={location.schedule} hasSchedule={location.hasSchedule} locationName={location.name} data-id="element-937" />
        <LocationContactForm preselectedLocationId={location.id} data-id="element-938" />
      </main>

      <Footer data-id="element-939" />
    </div>;
}